import Hero from "../components/site/Hero";
import ServicesMarquee from "../components/site/Marquee";
import Stats from "../components/site/Stats";
import Manifesto from "../components/site/Manifesto";
import Services from "../components/site/Services";
import Testimonials from "../components/site/Testimonials";
import LeadForm from "../components/site/LeadForm";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ServicesMarquee />
      <Stats />
      <Manifesto />
      <Services />
      <Testimonials />
      <LeadForm />
    </div>
  );
}
